import React, { memo, useEffect, useLayoutEffect } from 'react';
import { Header } from '../Header/header';
import { Footer } from '../Footer/footer';
import { IBlock } from '../../../../utils/types/contentful';
import ScrollProvider from '../../../../utils/providers/scroll';
import CartProvider from '../../../../utils/providers/cart';
import { Alert } from '../../Overlays/Alert/alert';
import { Popup } from '../../Overlays/Popup/popup';
import { CookieBanner } from '../../Overlays/Banner/Cookie/cookieBanner';
import { ErrorHandler } from '../../../Utils/Error/errorHandler';
import { Modal } from '../../Overlays/Modal/modal';
import { Sidebar } from '../../Overlays';
import { pushCurrentPageToDataLayer } from '../../../../utils/dataLayer/currentPage';
import { SEO } from '../../../Utils/Seos/seo';
import { SubHeader } from '../../Overlays/Sub/subHeader';
import { ThirdPartyScripts } from '../../../Utils/ThirdPartyScripts/thirdPartyScripts';
import ZoneCheck from '../../../Utils/ZoneCheck/zoneCheck';
import NoozApi, { setLocale, setToken } from '../../../../services/NoozApi';
import clsx from 'clsx';

export interface MainLayoutProps {
  header: IBlock;
  footer: IBlock;
}

export const QuizLayout = memo(
  ({
    isCollectionPage = false,
    backgroundColor,
    cart,
    children,
    cookieBanner,
    error,
    footer,
    header,
    popup,
    page,
  }) => {
    useLayoutEffect(() => {
      setToken(window.localStorage.getItem('userToken'));
    }, []);
    // Datalayer Page view
    useEffect(() => {
      setLocale();

      pushCurrentPageToDataLayer(page);
    }, []);

    return (
      <ErrorHandler error={error}>
        <ScrollProvider>
          <CartProvider cart={cart}>
            <Header {...header} />
            <main className='flex flex-col items-center relative'>
              <div
                className={clsx(
                  'main-wrapper z-1 flex flex-col items-center w-full',
                  { 'flex flex-col-reverse': isCollectionPage }
                )}>
                {children}
              </div>
              {/* grey backgroundColor */}
              <span
                style={{
                  backgroundColor: backgroundColor && backgroundColor.hex,
                }}
                className='h-full w-screen -z-1 absolute top-0 left-0'
              />
            </main>
            <Footer {...footer} />

            {/* Overlays */}
            <SubHeader />
            <CookieBanner {...cookieBanner} />
            <Popup {...popup} />
            <Alert />
            <Modal />
            <Sidebar />
            <div id='modal-root' />

            {/* Utils */}
            <ThirdPartyScripts page={page} />
            <ZoneCheck />
            <SEO {...page} />
          </CartProvider>
        </ScrollProvider>
      </ErrorHandler>
    );
  }
);
